import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModal from "../TransferTicketModal";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { Can } from "../Can";
import { AuthContext } from "../../context/Auth/AuthContext";

const TicketOptionsMenu = ({ ticket, menuOpen, handleClose, anchorEl }) => {
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const [resolveWithoutNpsOpen, setResolveWithoutNpsOpen] = useState(false);
	const history = useHistory();
	const isMounted = useRef(true);
	const { user } = useContext(AuthContext);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const handleDeleteTicket = async () => {
		try {
			await api.delete(`/tickets/${ticket.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleOpenConfirmationModal = e => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleOpenTransferModal = e => {
		setTransferTicketModalOpen(true);
		handleClose();
	};

	const handleCloseTransferTicketModal = () => {
		if (isMounted.current) {
			setTransferTicketModalOpen(false);
		}
	};

	const handleOpenResolveWithoutNpsModal = () => {
		setResolveWithoutNpsOpen(true);
		handleClose();
	};

	const handleConfirmResolveWithoutNps = async () => {
		try {
			await api.put(`/tickets/${ticket.id}`, {
				status: "closed",
				userId: user?.id || null,
				skipNps: true,
			});
			history.push("/tickets");
		} catch (err) {
			toastError(err);
		}
	};

	const handleShareTicket = async () => {
		handleClose();
		try {
			const { data } = await api.get(`/tickets/${ticket.id}/share-link`);
			const shareUrl = `${window.location.origin}/preview/${data.token}`;
			if (navigator.clipboard) {
				await navigator.clipboard.writeText(shareUrl);
				toast.success("📱 Link público do atendimento copiado com sucesso! 🚀");
			} else {
				window.open(shareUrl, "_blank");
			}
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<>
			<Menu
				id="menu-appbar"
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				keepMounted
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				<MenuItem onClick={handleShareTicket} style={{ color: "#0284c7", fontWeight: 600 }}>
					📱 Compartilhar (Link Público)
				</MenuItem>
				{user.profile === "admin" && (
					<MenuItem onClick={handleOpenResolveWithoutNpsModal} style={{ color: "#d97706", fontWeight: 500 }}>
						🤫 Encerrar sem Pesquisa NPS
					</MenuItem>
				)}
				<MenuItem onClick={handleOpenTransferModal}>
					{i18n.t("ticketOptionsMenu.transfer")}
				</MenuItem>
				<Can
					role={user.profile}
					perform="ticket-options:deleteTicket"
					yes={() => (
						<MenuItem onClick={handleOpenConfirmationModal}>
							{i18n.t("ticketOptionsMenu.delete")}
						</MenuItem>
					)}
				/>
			</Menu>
			<ConfirmationModal
				title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}${
					ticket?.id || ""
				} ${i18n.t("ticketOptionsMenu.confirmationModal.titleFrom")} ${
					ticket?.contact?.name || ""
				}?`}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteTicket}
			>
				{i18n.t("ticketOptionsMenu.confirmationModal.message")}
			</ConfirmationModal>
			<ConfirmationModal
				title={`Encerrar #${ticket?.id || ""} sem Pesquisa NPS`}
				open={resolveWithoutNpsOpen}
				onClose={setResolveWithoutNpsOpen}
				onConfirm={handleConfirmResolveWithoutNps}
			>
				Deseja realmente encerrar este atendimento sem enviar a pesquisa de satisfação (NPS)? A mensagem de despedida será enviada normalmente, mas a pesquisa não será disparada para este cliente.
			</ConfirmationModal>
			<TransferTicketModal
				modalOpen={transferTicketModalOpen}
				onClose={handleCloseTransferTicketModal}
				ticketid={ticket.id}
				ticketWhatsappId={ticket.whatsappId}
			/>
		</>
	);
};

export default TicketOptionsMenu;
